import { Service } from '@angular/core';
import { State } from '@ngxs/store';
import { CollectionDataServiceBase } from '@portal-core/data/collection/services/collection-data.service.base';
import { CollectionStateBase } from '@portal-core/data/collection/services/collection-state.base';
import { CollectionStateSelectors } from '@portal-core/data/collection/services/collection-state-selectors.decorator';
import { ProjectReportStatistics } from '@portal-core/reports/models/project-report-statistics.model';

@CollectionStateSelectors({
  stateType: ProjectReportStatisticsState
})
@State<ProjectReportStatisticsState>({
  name: ProjectReportStatisticsState.source
})
@Service({ autoProvided: false })
export class ProjectReportStatisticsState extends CollectionStateBase {
  static override source = 'ProjectReportStatistics';
  getSource(): string {
    return ProjectReportStatisticsState.source;
  }
}

@Service()
export class ProjectReportStatisticsDataService extends CollectionDataServiceBase<ProjectReportStatistics> {
  protected readonly stateType = ProjectReportStatisticsState;
}
